/** A band read that failed, said above the tiles whether or not the charts are open - ADR-0212, P9.
 *
 * The charts are collapsed by default, so a failure that was only drawn inside a chart card would be
 * invisible to the reader who never opens it: a tile's small line or change would simply be missing,
 * and a missing figure that nobody is told about reads as "nothing to say". Every read a band depends
 * on that the page does not already report is listed here, each as the shared `ReadFailed` with its
 * retry (an alert, so it is announced). Nothing is drawn in place of the failed figure, and never a
 * zero. The list itself is `components/Loaded`'s `ReadsFailed`, shared with the tile strips.
 */

import { ReadsFailed } from "../../components/Loaded";
import type { BandRead } from "./BandCard";

export function BandFailures({ reads }: { reads: ReadonlyArray<{ of: string; read: BandRead }> }) {
  return <ReadsFailed reads={reads} testId="band-failures" />;
}
